import { useEffect, useState } from 'react';

import {
  extractImageAccentColor,
  getFallbackImageAccentColor,
} from '@/utils/imageAccentColor';

export default function useImageAccentColor(source) {
  const [accentColor, setAccentColor] = useState(() => getFallbackImageAccentColor());

  useEffect(() => {
    let isActive = true;

    if (!source) {
      setAccentColor(getFallbackImageAccentColor());
      return undefined;
    }

    extractImageAccentColor(source).then((result) => {
      if (isActive) {
        setAccentColor(result);
      }
    });

    return () => {
      isActive = false;
    };
  }, [source]);

  return accentColor;
}
